import { Link } from 'react-router-dom';
import {
  HiDocumentText,
  HiShoppingCart,
  HiCurrencyRupee,
  HiScale,
  HiMail,
} from 'react-icons/hi';
import { trackContactClick } from '../utils/analytics';
import { STORE } from '../utils/store';
import '../styles/Policy.css';

/* Terms of Service. Same shell as the other policies. */

const TermsOfService = () => (
  <section className="policy-page">
    <div className="policy-container">
      <header className="policy-head">
        <h1>Terms of Service</h1>
        <p className="policy-updated">Last updated: 25 September 2026</p>
      </header>

      <div className="policy-body">
        <p className="policy-lead">
          By using the Celestial Stones website or placing an order, you agree
          to the terms below. Please read them before you buy.
        </p>

        <h2>
          <HiDocumentText aria-hidden="true" />
          Use of the Website
        </h2>
        <p>
          You agree to use this website only for lawful purposes, and not to
          do anything that disrupts or harms it or the people using it.
        </p>

        <h2>
          <HiShoppingCart aria-hidden="true" />
          Products &amp; Information
        </h2>

        <h3>Descriptions and photographs</h3>
        <p>
          We describe and photograph every piece as accurately as we can.
          Natural gemstones vary, so the stone you receive may differ slightly
          in colour, size and natural character from the one pictured.
        </p>

        <h3>Astrological information</h3>
        <p>
          Everything we say about a stone's planetary association is offered
          for <strong>informational purposes</strong> and reflects traditional
          belief. Results vary from person to person.
        </p>
        <ul className="policy-list">
          <li>Astrological effects are traditional beliefs, not guarantees</li>
          <li>Consult a qualified astrologer before you buy</li>
          <li>A gemstone is not a substitute for medical or professional advice</li>
        </ul>

        <div className="policy-callout is-good">
          <h3>Authenticity guaranteed</h3>
          <p>
            Every gemstone ships with a certificate from a recognised
            gemmological laboratory, and your money back if it is ever proven
            otherwise.
          </p>
        </div>

        <h2>
          <HiCurrencyRupee aria-hidden="true" />
          Pricing &amp; Payment
        </h2>
        <dl className="policy-facts">
          <div className="policy-fact">
            <dt>Prices</dt>
            <dd>Shown in Indian rupees and include all applicable taxes</dd>
          </div>
          <div className="policy-fact">
            <dt>Payment</dt>
            <dd>
              By UPI. We send the payment details on WhatsApp once your order
              is placed, and confirm the order once payment is received.
            </dd>
          </div>
          <div className="policy-fact">
            <dt>Discounts</dt>
            <dd>One coupon code per order, applied in the bag before checkout</dd>
          </div>
        </dl>
        <p className="policy-note">
          Prices may change without notice. If an item is listed at an
          incorrect price, we reserve the right to cancel the order and refund
          you in full.
        </p>

        <h2>Orders &amp; Cancellation</h2>
        <ul className="policy-list">
          <li>We may accept or decline any order at our discretion</li>
          <li>You can cancel an order within 24 hours, as long as it has not been dispatched</li>
          <li>A cancelled order is refunded in full within 7 business days</li>
        </ul>
        <p>
          Returns after delivery are covered by our{' '}
          <Link to="/shipping-returns">Shipping &amp; Returns</Link> policy.
        </p>

        <h2>
          <HiScale aria-hidden="true" />
          Limitation of Liability
        </h2>
        <p>
          Celestial Stones is not liable for indirect or consequential loss
          arising from the use of our products or this website, including:
        </p>
        <ul className="policy-list">
          <li>Indirect or consequential damages</li>
          <li>Loss of profit or business opportunity</li>
          <li>Failures of third-party services such as couriers or payment apps</li>
          <li>Events outside our reasonable control</li>
        </ul>
        <div className="policy-callout">
          <p>
            <strong>Maximum liability:</strong> in every case, limited to the
            amount you paid for the product concerned.
          </p>
        </div>

        <h2>Intellectual Property</h2>
        <p>
          All content on this website — text, photographs, the logo and other
          graphics — is the property of Celestial Stones and protected by
          copyright. It may not be copied or redistributed without permission.
        </p>

        <h2>Governing Law</h2>
        <p>
          These terms are governed by the laws of <strong>India</strong>. Any
          dispute falls under the exclusive jurisdiction of the courts of
          Delhi.
        </p>

        <h2>Changes to These Terms</h2>
        <p>
          We may update these terms from time to time. Changes take effect
          when they are posted on this page with a new date.
        </p>

        <h2>
          <HiMail aria-hidden="true" />
          Contact
        </h2>
        <p>Questions about these terms:</p>
        <dl className="policy-facts">
          <div className="policy-fact">
            <dt>Email</dt>
            <dd>
              <a
                href={`mailto:${STORE.email}`}
                onClick={() => trackContactClick('email', 'terms_of_service')}
              >
                {STORE.email}
              </a>
            </dd>
          </div>
          <div className="policy-fact">
            <dt>Response</dt>
            <dd>Within 24–48 hours</dd>
          </div>
        </dl>

        <div className="policy-foot">
          <p>
            By using this website you confirm that you have read, understood
            and agree to these Terms of Service.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default TermsOfService;
